module.exports = __webpack_public_path__ + "static/media/icon-arrow.b1a040c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-arrow.svg
// module id = 1557
// module chunks = 0